import demandConfig from 'services/metaData/demandConfig';

export const userMenuFullList = [
    [
        {
            id: 'myAccount',
            name: 'Account',
            path: '/account/generalInfo',
            icon: 'userIcon',
            iconWidth: 15,
            iconHeight: 15,
            iconClass: 'my-account-icon',
            showUserNameInMobileMode: true,
            disabled: false,
            disableTradingDesk: true
        },
        {
            id: 'accountManagement',
            name: 'User Management',
            path: '/accountManagement',
            disabled: false,
            hideOnMobile: true,
            permissions: ['manageOwnUsers or admin']
        },
        {
            id: 'fundsCompanyInfo',
            name: 'Company Info',
            hideOnMobile: true,
            path: '/funds/company/info',
            permissions: ['financialController', '!admin']
        }
    ],
    [
        {
            id: 'fundsPayments',
            name: 'Payments',
            hideOnMobile: true,
            path: '/funds/payments',
            permissions: ['monetizerFinancialView', '!admin']
        },
        {
            id: 'addFunds',
            name: 'Add Funds',
            hideOnMobile: true,
            path: demandConfig.getPathUrl('/add-funds'),
            permissions: ['allowAddFunds', '!admin'],
            externalRoute: true,
            openInNewTab: false
        }
    ],
    [
        {
            id: 'contactUs',
            name: 'Contact Us',
            hideOnMobile: true,
            path: '', // added in runtime, according to the logged user
            permissions: ['!admin'],
            externalRoute: true,
            openInNewTab: true
        }
    ],
    [
        {
            id: 'entrance',
            name: 'Logout',
            path: '/logout',
            icon: 'logoutIcon',
            iconWidth: 18,
            iconHeight: 15,
            iconClass: 'logout-icon',
            disabled: false
        }
    ]
];
